<template>
  <div>
    <Header />
    <main id="main">
      <div class="container">
        <h1>Search the {{tenant_name}} Directory</h1>      
        <br>
        <SearchBar :isLandingPage="true" @noResultFound="onNoResultFound" @searching="onSearching"/>
        <div class="loader" v-if="searching">
          <strong>Searching<span class="loader__dot">.</span><span class="loader__dot">.</span><span class="loader__dot">.</span></strong>
        </div>
        
         <p v-if="noResultFound && !searching">  
            <br/>         
            <strong>{{ noResultMessage }}</strong>
          </p>         
      </div>
    </main>
  </div>
</template>

<script>
import Header from "@/components/header.vue";
import SearchBar from "@/components/search-bar.vue";

export default {
  name: "Search",
  data() {
    return {
      tenant_name: process.env.VUE_APP_TENANT_NAME,      
      noResultMessage: process.env.VUE_APP_STATIC_NORESULT_MESSAGE,
      noResultFound:false,
      searching:false
    };
  },
  components: { Header, SearchBar },
  mounted() {
    document.body.classList.add("dashboard");
  },
  destroyed() {
    document.body.classList.remove("dashboard");
  },
  methods: {
    onNoResultFound(value){
      this.noResultFound = value;
    },
    onSearching(value){
      this.searching = value;
    }
  },
  
};
</script>

<style>
</style>